import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/lib/select/style/index.css'
import VueHtml2Canvas from 'vue-html2canvas'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import darkUnica from 'highcharts/themes/dark-unica'

import './assets/css/metronic/layout.min.css'
import './assets/css/antd.css'
import './assets/css/bulma.css'
import './assets/css/tutruxxx.css'
import './assets/css/_form.css'
import './assets/css/_reboot.css'
import './assets/css/_grid.css'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(VueHtml2Canvas)
darkUnica(Highcharts)
Vue.use(HighchartsVue)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
